import { Link, router, usePage } from "@inertiajs/react"
import { LogOut } from "lucide-react"

import { Logo } from "@/components/logo"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { dashboardPath, pricingPath, sessionPath, signInPath } from "@/routes"
import type { Auth } from "@/types"

const navLinkBase =
  "text-sm focus-visible:ring-ring/50 focus-visible:ring-[3px] rounded outline-none"

export function PublicHeader() {
  const page = usePage<{ auth: Auth | null }>()
  const { auth } = page.props
  const url = page.url ?? ""

  const isToolsPage = url === "/" || url.includes("-pdf")
  const isPricingPage = url.startsWith("/pricing")

  return (
    <header className="border-b">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Logo />
        <nav className="flex items-center gap-4">
          <Link
            href="/"
            className={cn(
              navLinkBase,
              isToolsPage
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            PDF Tools
          </Link>
          <Link
            href={pricingPath()}
            className={cn(
              navLinkBase,
              isPricingPage
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            Pricing
          </Link>
          {auth ? (
            <>
              <Link
                href={dashboardPath()}
                className="text-muted-foreground hover:text-foreground text-sm"
              >
                Dashboard
              </Link>
              <Link
                method="delete"
                href={sessionPath({ id: auth.session.id })}
                as="button"
                className="inline-flex items-center justify-center rounded-md border px-3 py-1.5 text-sm font-medium"
                onClick={() => router.flushAll()}
              >
                <LogOut className="mr-2 h-4 w-4" />
                Log out
              </Link>
            </>
          ) : (
            <Link href={signInPath()}>
              <Button variant="outline" size="sm">
                Sign In
              </Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  )
}
